import {isNotNil} from 'ramda';

import {VehicleFinancingTemplateResponseBody} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {getInitialRateMatrixValue} from '../../RateMatrix/utils/getInitialRateMatrixValue';
import {VehicleFinancingTemplateFormValues} from '../vehicleFinancingTemplateFormSchema';
import {mapResponseToFormValues} from './mapResponseToFormValues';

function getEmptyFormValues(): VehicleFinancingTemplateFormValues {
  return {
    name: '',
    type: ['STANDARD'],
    validityMode: 'UNLIMITED',
    validFrom: null,
    validTo: null,
    expirationAction: null,
    replacementTemplateId: null,
    interestRateType: [],
    downPaymentStep: ['FIVE_PERCENT'],
    balloonPaymentStep: [],
    financialInstitutionCodeId: '',
    processingFee: null,
    vehicleTransferIncluded: false,
    vehicleTransferAmount: null,
    vehicleRegistrationIncluded: false,
    vehicleRegistrationAmount: null,
    vehicleDeliveryIncluded: false,
    vehicleDeliveryAmount: null,
    tradeInPossible: false,
    creditProtectionAutoEnable: false,
    scope: {
      mode: 'ALL_VEHICLES',
      branchIds: [],
      segment: {
        makes: [],
        models: [],
        vehicleCategories: [],
        fuelTypes: [],
        yearFrom: null,
        yearTo: null,
        mileageFrom: null,
        mileageTo: null,
        sellingPriceFrom: null,
        sellingPriceTo: null,
      },
    },
    rateMatrix: getInitialRateMatrixValue(undefined),
  };
}

export function getInitialFormValues(
  template: VehicleFinancingTemplateResponseBody | Nullish
): VehicleFinancingTemplateFormValues {
  if (isNotNil(template)) {
    return mapResponseToFormValues(template);
  }

  return getEmptyFormValues();
}
